import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, Select } from '@ngxs/store';
import { FetchOrdersAndReorders } from '../core/store/order/orders.actions';
import { OrdersState } from '../core/store/order/orders.state';
import { Order, Patient } from '../core/models';
import { CcsSentryError } from '../core/store/utils';
import { PatientState } from '../core/store/patient/patient.state';
@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss'],
})
export class OrdersComponent implements OnInit {
  @Select(PatientState.patient) patient$!: Observable<Patient | null>;
  @Select(OrdersState.isLoading) isLoading$!: Observable<boolean>;
  @Select(OrdersState.error) error$!: Observable<CcsSentryError | null>;
  @Select(OrdersState.activeOrders) activeOrders$!: Observable<Order[]>;
  @Select(OrdersState.completedOrders) completedOrders$!: Observable<Order[]>;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(new FetchOrdersAndReorders());
  }
}
